import { TextField as TextFieldBase } from '@mui/material';

type TextFieldProps = React.ComponentProps<typeof TextFieldBase>;
const TextField = ({ sx, ...props }: TextFieldProps) => {
  return (
    <TextFieldBase
      {...props}
      sx={{
        minWidth: 220,
        '& .MuiFilledInput-root': {
          height: {
            xs: 36,
            md: 48
          },
          boxSizing: 'border-box',
          alignItems: 'center'
        },
        '& .MuiInputBase-input': {
          fontSize: {
            xs: '0.875rem',
            md: '1rem'
          },
          paddingTop: 1,
          paddingBottom: 0,
          paddingLeft: 2
        },
        '& .MuiInputLabel-filled': {
          fontSize: {
            xs: '0.875rem',
            md: '1rem'
          },
          transform: {
            xs: 'translate(16px, 8px) scale(1)',
            md: 'translate(16px, 12px) scale(1)'
          },
          '&.MuiInputLabel-shrink': {
            transform: {
              xs: 'translate(16px, 1px) scale(0.6)',
              md: 'translate(16px, 2px) scale(0.75)'
            }
          }
        }
      }}
    />
  );
};
export default TextField;
